<template>
	<footer class="bg-blue-dark py-8 sm:py-12 relative overflow-hidden">
		<section class="container xl:max-w-5xl mb-16">
			<h4 class="text-white font-bold text-base mb-4">
				{{ locale === 'en' ? 'LEGAL' : 'RECHTLICHES' }}
			</h4>
			<nuxt-link to="https://hokify.at/imprint" class="text-white hover:underline inline-block">{{
				locale === 'en' ? 'Imprint' : 'Impressum'
			}}</nuxt-link>
			<br />
			<nuxt-link
				to="https://hokify.at/accessibility"
				class="text-white hover:underline inline-block"
				>{{ locale === 'en' ? 'Accessibility statement' : 'Barrierefreiheitserklärung' }}</nuxt-link
			>
			<br />
			<nuxt-link to="https://hokify.at/privacy" class="text-white hover:underline inline-block">{{
				locale === 'en' ? 'GDPR' : 'Datenshutz'
			}}</nuxt-link>
		</section>
		<section class="mb-12 container xl:max-w-5xl flex flex-col lg:flex-row justify-between">
			<div class="z-10 mb-12 lg:mb-0 text-center sm:text-left">
				<h4 class="text-white font-bold text-base mb-4 sm:mb-8">
					{{ locale === 'en' ? 'OUR PARTNERS' : 'UNSERE PARTNER' }}
				</h4>
				<div class="inline-block">
					<nuxt-link
						v-for="logo in getPartnerLogos"
						:key="logo.imgSource"
						:to="logo.imgLink"
						target="_blank"
						class="mx-8 mt-3 sm:mt-0 sm:mr-8 sm:ml-0 relative highlight inline-block"
					>
						<img
							:src="getAssetSrc(logo.imgSource)"
							:alt="logo.imgAlt"
							class="inline-block h-10 lg:h-8 align-middle white-filter"
							height="40"
						/>
					</nuxt-link>
				</div>
			</div>
			<div class="z-20">
				<h4 class="text-white text-center sm:text-left text-base font-bold mb-6">
					{{ locale === 'en' ? 'FOLLOW US' : 'FOLGE UNS' }}
				</h4>
				<nav class="flex space-x-4 sm:space-x-6 justify-center">
					<nuxt-link
						to="https://www.tiktok.com/@hokify"
						class="highlight bg-white rounded-full h-10 w-10 flex items-center justify-center"
					>
						<img :src="tikTokIcon" alt="Tiktok Logo" aria-label="Tiktok Logo" class="h-5 w-5" />
					</nuxt-link>
					<nuxt-link
						to="https://instagram.com/hokify"
						class="highlight bg-white rounded-full h-10 w-10 flex items-center justify-center"
					>
						<img
							:src="instagram"
							alt="Instagram Logo"
							aria-label="Instagram Logo"
							class="h-5 w-5"
						/>
					</nuxt-link>
					<nuxt-link
						to="https://facebook.com/hokify.at"
						class="highlight bg-white rounded-full h-10 w-10 flex items-center justify-center"
					>
						<img :src="facebook" alt="Facebook Logo" aria-label="Facebook Logo" class="h-8 w-8" />
					</nuxt-link>
				</nav>
			</div>
			<div class="z-30 mt-6 md:mt-0">
				<h4 class="text-white text-center sm:text-left text-base font-bold mb-6">
					HOL DIR DIE APP
				</h4>
				<div class="flex items-center justify-center sm:justify-start space-x-6">
					<nuxt-link
						to="https://itunes.apple.com/us/app/hokify-job-app/id1069568033?l=de&ls=1&mt=8"
						styling="inline-block"
						link-type="external"
					>
						<img
							width="120"
							height="40"
							src="~/assets/img/app-stores/app_store.png"
							alt="Download hokify im Apple App Store"
						/>
					</nuxt-link>
					<nuxt-link
						to="https://play.google.com/store/apps/details?id=com.yfabrik.hocknfinder"
						styling="inline-block"
						link-type="external"
					>
						<img
							width="120"
							height="40"
							src="~/assets/img/app-stores/play_store.png"
							alt="Download hokify im Google Play Store"
						/>
					</nuxt-link>
				</div>
			</div>
		</section>
		<p class="relative z-10 mb-0 text-sm text-white text-center">
			hokify GmbH | part of the norika group
		</p>
		<img
			class="absolute bottom-0 left-0 z-0"
			src="~assets/svgs/hokify/hy_footer.svg"
			alt="Footer SVG Grafik"
		/>
	</footer>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { getPartnerLogos } from '@hokify/shared-components-nuxt3/lib/helpers/logos';
import facebookUrl from '~/assets/svgs/icons/icon-facebook.svg';
import instagramUrl from '~/assets/svgs/icons/icon-instagram-footer.svg';
import tikTok from '~/assets/svgs/icons/icon-tiktok.svg';

export default defineComponent({
	name: 'HokFooter',
	data() {
		const facebook = facebookUrl;
		const instagram = instagramUrl;
		const tikTokIcon = tikTok;
		return {
			facebook,
			instagram,
			tikTokIcon,
			getPartnerLogos: getPartnerLogos('at', 'footer'),
			// locale: this.$store.state.locale
			locale: 'at'
		};
	},
	methods: {
		// works - but performance might be bad?
		// how can we access @shared-components without accessing node_modules?
		getAssetSrc(name: string) {
			const path = `../../node_modules/@hokify/shared-components-nuxt3/assets/svgs/logos/${name}`;
			const modules = import.meta.glob(
				'../../node_modules/@hokify/shared-components-nuxt3/assets/svgs/logos/**/*',
				{
					eager: true
				}
			) as Record<string, { default: string }>;

			if (modules[path]) {
				return modules[path].default;
			}
			return '';
		}
	}
});
</script>

<style scoped lang="scss">
.white-filter {
	filter: brightness(0) invert(1);
}
</style>
